export default __webpack_public_path__ + "static/media/menuCompartilhar.efac3abf.svg";